export interface IGenderStatic {
  title: string;
  tag: string;
}

export const GENDER_LIST: IGenderStatic[] = [
  {
    title: 'Woman',
    tag: 'F'
  },
  {
    title: 'Non-binary',
    tag: 'U'
  },
  {
    title: 'Man',
    tag: 'M'
  }
];
